import { render, staticRenderFns } from "./NewCi.vue?vue&type=template&id=36f18db0&"
import script from "./NewCi.vue?vue&type=script&lang=js&"
export * from "./NewCi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports